import './App.scss';
import Navigation from './Navigation';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import HelperService from './utility/HelperService';
import { meCallRequest, permissionsCallRequest } from './screens/onBoarding/onBoardingActions';

function App() {
    // const token = useSelector((state: any) => state.OnBoardingReducer);
    // const dispatch = useDispatch();

    // useEffect(() => {
    //     token && token.token && (!token.user || HelperService.isEmptyObject(token.user)) && dispatch(meCallRequest());
    //     token && token.token && token.permissions && !token.permissions.length && dispatch(permissionsCallRequest());
    // }, []);

    return (
        <div className="App">
            <Navigation />
            <ToastContainer />
        </div>
    )
};
export default App;